// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueRouter from "vue-router";
import Vuelidate from "vuelidate";
import App from "./App.vue";
import store from "./store";
import http from "./utils/Http.util";

import Token from "./utils/Token.util";

// router setup
// import { routes } from "./routes";
import router from "./routes";

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";

Vue.use(Vuelidate);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(VueRouter);

// const router = new VueRouter({
//   routes, // short for routes: routes
//   linkExactActiveClass: "nav-item active",
//   // linkActiveClass: "nav-item active",
//   mode: "history"
// });

http.interceptors.push({
  onResponse: res => res,
  onError: error => {
    if (error.response.status == 401) {
      Token.unsetToken();
      store.commit("resetState");
      router.replace("/signin");
    }
    return Promise.reject(error);
  }
});

new Vue({
  el: "#app",
  store,
  router,
  render: h => h(App)
});
